import { BsFileTextFill } from 'react-icons/bs';
import { MessageChatProps } from '../../../../../context/ChatWhatsAppContext'
import { IoOpenOutline } from 'react-icons/io5';

interface ClientMessageProps extends MessageChatProps {
  type: string
}

export const ClientMessage = ({ text, time, type, linkImage, documentName }: ClientMessageProps) => {

  function previewButton() {
    window.open(linkImage, '_blank')
  }

  const dividirEmLinhas = (texto: string) => {
    const regexPix = /[0-9]{2,}\.?[0-9]{3,}\.?[0-9]{3,}\/?[0-9]{4,}-?[0-9]{2,}/;
    if (regexPix.test(texto) || !/\s/.test(texto)) {
      return texto.match(/.{1,40}/g)?.join('\n') || [];
    }

    return texto
  };


  function renderMessage() {
    if (type === "image") {
      return <img src={linkImage} alt="" className='' />
    } else if (type === 'document') {
      return (
        <div className='flex items-center gap-2 text-xs'>
          <BsFileTextFill size={22} className="fill-white" />
          <p className='text-center'>Documento</p>
          <button onClick={previewButton}>
            <IoOpenOutline size={22} className="fill-white" />
          </button>
        </div>
      )
    } else if (type === "audio") {
      return <audio src={linkImage} controls className='h-10' />
    } else if (type === "video") {
      return <video src={linkImage} controls className='h-[90%] w-[90%]' />
    }
    else {
      return <p className="text-xs">{dividirEmLinhas(text)} </p>
    }
  }
  return (
    <div className="m-2 mt-0 flex w-full max-w-xs space-x-3">
      <div>
        {/* bg-gray-300 */}
        <div className="rounded-r-lg rounded-bl-lg bg-white p-2">
          {/* <p className="text-xs">
            {text}
          </p> */}

          {renderMessage()}
        </div>
        <span className="text-[10px] leading-none text-gray-500">
          {time}
        </span>
      </div>
    </div>
  );
};
